
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface TimeSlotCreateFormButtonsProps {
  isSubmitting: boolean;
  onCancel: () => void;
}

const TimeSlotCreateFormButtons: React.FC<TimeSlotCreateFormButtonsProps> = ({
  isSubmitting,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex-shrink-0 space-y-3 pt-4">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={isSubmitting}
        className="w-full"
      >
        {t('common.cancel')}
      </Button>
      <Button type="submit" disabled={isSubmitting} className="w-full">
        {isSubmitting ? t('schedule.creating') : t('common.save')}
      </Button>
    </div>
  );
};

export default TimeSlotCreateFormButtons;
